import { MiddlewareAPI, Dispatch, Action } from 'redux';
import rdiff from 'recursive-diff';

import { Actions } from './actions';
import {
    LOAD_PRESCRIPTION,
    pushDiff,
    UNDO_ACTION,
    CLEAR_PRESCRIPTION_PAD,
    UPDATE_PATIENT,
    SET_FOLLOWUP,
    UPDATE_REFERAL,
    PUSH_DIFF,
    SET_VITALS,
} from './actions/prescriptionPad';
import { GlobalState } from './reducers';
import { UPDATE_PT_COLUMNS } from './actions/genie';

const createUndoReduxMiddleware = () => (api: MiddlewareAPI<Dispatch, GlobalState>) => {
    return (next: Dispatch<Actions>) => (action: Action) => {
        if (
            action.type === LOAD_PRESCRIPTION ||
            action.type === CLEAR_PRESCRIPTION_PAD ||
            action.type === UPDATE_PATIENT ||
            action.type === UPDATE_PT_COLUMNS
        ) {
            return next(action);
        }

        if (
            action.type === PUSH_DIFF ||
            action.type === UNDO_ACTION ||
            action.type === SET_FOLLOWUP ||
            action.type === SET_VITALS ||
            action.type === UPDATE_REFERAL
        ) {
            return next(action);
        }

        const oldState = api.getState().prescriptionPad.prescription;
        const result = next(action);
        const newState = api.getState().prescriptionPad.prescription;

        const diff = rdiff.getDiff(newState, oldState, true);

        if (diff.length > 0) {
            api.dispatch(pushDiff(diff));
        }

        return result;
    };
};

const undoReduxMiddleware = createUndoReduxMiddleware();

export default undoReduxMiddleware;
